export const getBlogPosts = state => state.blogCards;

export const getScrollPosition = state => state.scrollPosition;

export const getBlogPaginationSettings = state => state.blogPaginationSettings;

// TODO: remove after connect to backend
export const getPostMock = state => state.postMock;